(function () {
  function initFaqs(root) {
    var items = root.querySelectorAll('.fq-item');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-fq-trigger]');
      var panel = item.querySelector('[data-fq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.hasAttribute('data-fq-open');

        if (isOpen) {
          closeItem(item, trigger, panel);
        } else {
          openItem(item, trigger, panel);
        }
      });
    });

    function openItem(item, trigger, panel) {
      item.setAttribute('data-fq-open', '');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      // Force reflow so the height transition runs from 0
      panel.style.height = '0px';
      var target = panel.scrollHeight;
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });
      panel.addEventListener('transitionend', function handler() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handler);
      });
    }

    function closeItem(item, trigger, panel) {
      var current = panel.scrollHeight;
      panel.style.height = current + 'px';
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
      item.removeAttribute('data-fq-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.addEventListener('transitionend', function handler() {
        panel.hidden = true;
        panel.removeEventListener('transitionend', handler);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.fq-section').forEach(initFaqs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('.fq-section');
    if (section) initFaqs(section);
  });
})();
